import React, { PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { listViewStyles } from '../../../styles';
import { ITopicItem } from '../../../../dataObjects/models/topics/TopicItem';
import TopicItemsListViewItem from './TopicItemsListViewItem';
import { IUserAccessPermissionsForObject, UserAccessPermissionsForObject } from '../../../../dataObjects/models/collaboration/ObjectUserPermissions';
import { IUser } from '../../../../dataObjects/models/users/User';
import { IChannel } from '../../../../dataObjects/models/channels/Channel';
import { ITopicItemViewModel } from '../../../../dataObjects/viewModels/topicItemViewModel';


export interface ITopicItemsListViewProps extends PropsWithChildren<unknown> {
  topicItemViewModels: Array<ITopicItemViewModel>;
  currentUser: IUser;
  channel: IChannel;
  onDelete: (topicItem: ITopicItem) => void;
  onDeleteProfileImage: (topicItemViewModel: ITopicItemViewModel) => void;
}

export const TopicItemsListView: React.FC<ITopicItemsListViewProps> = (props: ITopicItemsListViewProps) => {
  TopicItemsListView.displayName = 'TopicItems List View';

  // eslint-disable-next-line no-console
  // console.info(`Render TopicItemsListView`);

  const classes: Record<string, string> = listViewStyles();

  const { topicItemViewModels, currentUser, channel, onDelete, onDeleteProfileImage } = props;

  const userPermissions: IUserAccessPermissionsForObject = new UserAccessPermissionsForObject(currentUser.id, channel);

  return (
    <>
      {/* overall grid for list. There will be a header row and two data rows: 
          - Header Row
          - Data Row 1: Name & Action Buttons
          - Data Row 2: Description
      */}
      <Grid container direction="column" >
        {/* Header Row */}
        <Grid key='tableHeader' container className={classes.tableHeader} size={12} direction="row">
          <Grid key='nameAndDescriptionLabel' size={{ xs: 12, md: 9 }}>
            <Typography variant='h6'>
              Name / Description
            </Typography>
          </Grid>
          <Grid container size={{ md: 3 }} direction="row" justifyContent="center" alignContent="flex-start">
            <Grid key='topicItemItemsLabel' container className={classes.actionButtonLabelContainer} size={{ md: 4 }} justifyContent='center' >
              {/* Only display the next label if the screen size is Medium or larger */}
              <Box sx={{ display: { xs: 'none', md: 'block' } }} >
                <Typography variant='h6'>
                  Digital Media
                </Typography>
              </Box>
            </Grid>
            <Grid key='editLabel' container className={classes.actionButtonLabelContainer} size={{ md: 4 }} justifyContent='center' >
              {/* Only display the next label if the screen size is Medium or larger */}
              <Box sx={{ display: { xs: 'none', md: 'block' } }} >
                <Typography variant='h6'>
                  Edit
                </Typography>
              </Box>
            </Grid>
            <Grid key='deleteLabel' container className={classes.actionButtonLabelContainer} size={{ md: 4 }} justifyContent='center' >
              {/* Only display the next label if the screen size is Medium or larger */}
              <Box sx={{ display: { xs: 'none', md: 'block' } }} >
                <Typography variant='h6'>
                  Delete
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        {
          currentUser && channel &&
          topicItemViewModels.map((topicItemViewModel, idx) => (
            <TopicItemsListViewItem
              key={topicItemViewModel.topicItem.id}
              topicItemViewModel={topicItemViewModel}
              userPermissions={userPermissions}
              onDelete={onDelete}
              onDeleteProfileImage={onDeleteProfileImage}
            />
          ))
        }
      </Grid>
    </>
  );
};

export default TopicItemsListView;
